module.exports = __webpack_public_path__ + "static/media/screenshot1.1b04e367.png";